<template>
  <div>
    <loader :loading="loading"></loader>
    <div class="row">
      <div class="col-md-6 mb-4">
        <h2>Add Role</h2>
      </div>
    </div>
    <div v-if="errorMessage.length" class="row">
      <div class="col-md-8">
        <base-alert class="text-center" type="danger" v-html="errorMessage"></base-alert>
      </div>
    </div>
    <validation-observer v-slot="{ handleSubmit }" ref="role">
      <form @submit.prevent="handleSubmit(addRole)">
        <div class="row">
          <div class="col-md-3">
            <validation-provider rules="requiredField" v-slot="{ errors }">
              <base-input
                label="Name"
                addon-left-icon="tim-icons icon-single-02"
                :error="errors[0]"
                v-model="rolename">
              </base-input>
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mt-3">
            <base-button native-type="submit" type="primary" class="mb-3">
              Create Role
            </base-button>
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { BaseAlert } from 'src/components';
  import swal from 'sweetalert2';
  import { addRole } from 'src/modules/adminActions';

  export default {
    components: {
      Loader,
      ValidationObserver,
      ValidationProvider,
      BaseAlert
    },
    data() {
      return {
        rolename: null,
        errorMessage: '',
        loading: false
      };
    },
    methods: {
      addRole() {
        this.loading = true;

        let payload = {
          RoleName: this.rolename,
        };

        addRole(payload)
        .then(response => {
          let identityResult = response.data;

          this.errorMessage = '';

          if(identityResult.errors && identityResult.errors.length) {
            identityResult.errors.forEach(error => {
              this.errorMessage += `${error.description}<br>`
            });
          }
          else {
            swal('Role Added!', 'Go to the Roles route to verify.', 'success');
            this.rolename = null;
            this.$refs.role.reset();
          }
        })
        .finally(() => {
          this.loading = false;
        })
      }
    }
  }
</script>
